import { render } from "./SliderImg.vue?vue&type=template&id=000b8b9a"
import script from "./SliderImg.vue?vue&type=script&lang=js"
export * from "./SliderImg.vue?vue&type=script&lang=js"

import "./SliderImg.vue?vue&type=style&index=0&id=000b8b9a&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__